import { render, staticRenderFns } from "./TranslatePage.vue?vue&type=template&id=10aff696&scoped=true"
import script from "./TranslatePage.vue?vue&type=script&lang=js"
export * from "./TranslatePage.vue?vue&type=script&lang=js"
import style0 from "./TranslatePage.vue?vue&type=style&index=0&id=10aff696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aff696",
  null
  
)

export default component.exports